export async function submitDiagnosis(payload) {
  const webhookPath = (process.env.REACT_APP_N8N_WEBHOOK_URL || "/api/n8n-webhook").trim();
  const apiKey = process.env.REACT_APP_N8N_API_KEY;

  if (!webhookPath || !apiKey) {
    throw new Error("Configuração do webhook não encontrada.");
  }

  const webhookUrl = webhookPath.startsWith("http")
    ? webhookPath
    : webhookPath.startsWith("/")
      ? webhookPath
      : `/${webhookPath}`;

  const response = await fetch(webhookUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-API-Key": apiKey,
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    throw new Error(`Falha ao enviar solicitação (${response.status}).`);
  }
}
